import { connect } from "react-redux";
import { setPopupChildren, togglePopup } from "../../redux/actions/app.action";
import { DispatchType } from "../../redux/types";
import HomePage from "./HomePage";


const mapDispatchProps = (dispatch: DispatchType) => ({
  togglePopup: (data: {isPopupOpen: boolean}) => togglePopup(data)(dispatch),
  setPopupChild: (data: JSX.Element, onDismiss?: any) => setPopupChildren(data, onDismiss)(dispatch)
})

export default connect(null, mapDispatchProps)(HomePage);